module.exports = __webpack_public_path__ + "img/English-Installation-step-2.7dc51b5d.png";